<div style="padding-top:20px;padding-left:20px;">
    <button type="button" class="hotline-btn" (click)="information()" [ngClass]="infoclick">INFORMATION</button>
    <button type="button" class="hotline-btn" (click)="hintsAndTips()" [ngClass]="hintsclick">HINTS AND TIPS</button>
    <button type="button" class="hotline-btn" (click)="submitCase()" [ngClass]="submitclick">{{'SUBMIT CASE'|translate}}</button>
</div>
<div *ngIf="informa">
    <div *ngIf="showfirsthot">
        <div class="container">
            <h2 style="margin-left:0px;">{{'Technical Hotline'|translate}}</h2>
            <div class="sect" style="margin-bottom:15px;">
                <p class="para1">The Technical Hotline was introduced by Ford in Europe in 1993 in recognition of the
                    increasing demands upon Dealers and Technicians with new complex vehicle technologies.</p>
                <p class="para1">The mission of the Technical Hotline is to:</p>
                <ul>
                    <li>
                        <p class="listitem">Provide repairers with prompt technical assistance and complete and accurate
                            resolution information on difficult to diagnose customer complaints.</p>
                    </li>
                    <li>
                        <p class="listitem">Record electronic details of all calls to improve concern resolution
                            process, design, development and manufacturing process.</p>
                    </li>
                </ul>
                <p class="para1">The Technical Hotline is an on-demand service. This means that a Hotline Engineer is
                    available to take a telephone call and to help callers to resolve concerns over valid technical
                    enquiries. Hotline Engineers establish the Customer's concern, analyse available data and make a
                    recommendation for the most appropriate repair following a joint decision with the Technician on a
                    course of action.</p>
                <p class="para1">The focus of the Technical Hotline is to improve the first time right repair fix rate
                    and customer satisfaction.</p>
                <p class="para1">The Technical Hotline should only be used for genuinely serious cases. For this reason,
                    callers must comply with the process detailed under <a class="static" style="color: red;
                    text-decoration: none;" (click)="linkForTechHotline()">Using the Technical Hotline</a>.</p>
                <p class="para1">Contact your nearest Technical Hotline Center - <b><span class="prompt">Technical
                            Hotline
                        </span>Telephone: 01206 732200
                    </b>
                </p>
            </div>
        </div>
    </div>
    <div *ngIf="showsecondhot">
        <div class="content-wrapper">
            <div class="container">
                <h2 style="margin-left:0px;margin-bottom:5px;margin-top: 5px;">Using the Technical Hotline</h2>
                <div class="sect">
                    <h2 class="title2"></h2>
                    <table style="width:99%; border:solid 1px grey; ">
                        <thead>
                            <tr >
                                <th>Who</th>
                                <th>What</th>
                                <th>How</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="width:20%">Receptionist</td>
                                <td style="width:20%">Accurate description of customer concern</td>
                                <td style="width:20%">Reception and accurate description of concern.</td>
                                <td style="width:20%"></td>
                                <td style="width:20%"></td>
                            </tr>
                            <tr>
                                <td>Receptionist</td>
                                <td>Road test</td>
                                <td>If necessary, road test the vehicle (with the customer) for accurate diagnosis.</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Receptionist/Technician</td>
                                <td>Repair allocation</td>
                                <td>Vehicle handover to technician with appropriate training and sufficient expertise.</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{'Technician'|translate}}</td>
                                <td>Check OASIS® and FordEtis</td>
                                <td>Check OASIS® by entering the VIN and symptom code for the affected concern.
                                    Carefully read at all <b>Broadcast Messages</b> and <b>Special Service Messages</b>.
                                    Check the <b>Technical Service Bulletins (TSB), Hints and Tips website </b> and/or
                                    the <b>Local Dealerportal</b>. Note the 9-digit-hotline-contact-ID.
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{{'Technician'|translate}}</td>
                                <td>Fault diagnosis</td>
                                <td>Use all available Service Instructions/Dealer Information:
                                    <ul>
                                        <li>
                                            <b>FordEtis</b>
                                            <ul>
                                                <li>Repair instructions</li>
                                                <li>Vehicle Systems Test Manuals and Diagnostics Manuals</li>
                                                <li>Wiring Diagrams</li>
                                                <li>Technical Service Bulletins (TSB)</li>
                                                <li>Diagnostic tools, e.g. FordEtis IDS</li>
                                            </ul>
                                        </li>
                                        <li>
                                            <b>FordEcat</b>
                                        </li>
                                    </ul>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Technician, Foreman,Receptionist, Manager</td>
                                <td>Use internal knowledge</td>
                                <td>Ask around the dealership to make use of internal knowledge.</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Technician, Foreman,Receptionist, Manager</td>
                                <td>Call the Hotline</td>
                                <td>Contact the Hotline by telephone and have the following information available:
                                    9-digit-hotline-contact-ID, mileage, FordEtis IDS datalogger results etc.
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="paras"></p>
                    <p class="paras">Contact your nearest Technical Hotline Center -
                        <b><span class="prompt">Technical Hotline
                            </span>Telephone: 01206 732200</b>
                    </p>
                    <p class="paras">
                        <a class="static" (click)="onClickBack()">Back</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="hintstips">Hints an dtips page has to be implemented</div>
<div *ngIf="submit">
    <div class="container">
        <div class="row">
            <div class="grid">
                <div class="grid__item one-whole">

                    <div class="b" style="padding: 5px;width: 95%;">
                        <fieldset class="c">
                            <legend class="d">Attached Session</legend>
                            <form id="CreateCaseForm">
                                <input type="hidden" name="org.apache.struts.taglib.html.TOKEN"
                                    value="72af8bb117c47c56475041d0921e7c7a">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <h4><b>Case Type:</b> </h4>
                                    </div>
                                    <div class="col-lg-6">
                                        <select id="caseType" class="dropdown">

                                            <option class="option-hotline" value="HAR">Hotline Assistance Request
                                            </option>

                                        </select>
                                    </div>
                                </div>
                                <div id="userInformation">
                                    <input type="hidden" name="countryCode" id="countryCode" value="GBR">
                                    <input type="hidden" name="langCode" id="langCode" value="en-GB">
                                    <input type="hidden" name="userId" id="userId" value="d-kancha">
                                    <input type="hidden" name="fName" id="fName" value="DS">
                                    <input type="hidden" name="lName" id="lName" value="Kanchana">
                                    <input type="hidden" name="email" id="email" value="KDHANASA@ford.com">
                                    <input type="hidden" name="vin" id="userVin" value="WF0RXXWPGRHU38253">
                                    <input type="hidden" name="smsNumber" id="smsNumber" value="020852634111">
                                </div>
                                <div id="sessionInformation">
                                    <input type="hidden" name="odometer" id="odometer">
                                    <input type="hidden" name="odoUnit" id="odoUnit">
                                    <input type="hidden" name="warrStartDate" id="warrStartDate" value="23/03/2017">
                                    <input type="hidden" name="warrantyDealerCode" id="warrantyDealerCode">
                                </div>
                                <div id="dealerInformation">
                                    <input type="hidden" name="dealername" id="dealername" value="Ford Training">
                                    <input type="hidden" name="pacode" id="pacode" value="GBRTEST11">
                                </div>
                                <input type="hidden" id="attachSession">
                                <div id="sessionAttached" style="display: none;" class="grid">
                                    <div class="grid__item three-twelfths" style="margin-top: 23px;">
                                        <h4>VIN: </h4>
                                    </div>
                                    <div class="grid__item nine-twelfths" style="padding-left: 0px; ">
                                        <input type="text" id="vin" readonly="true" style="width:65%"
                                            disabled="disabled">
                                    </div>
                                    <div class="grid__item three-twelfths" style="margin-top: 23px;">
                                        <h4>Manufacturer ID: </h4>
                                    </div>
                                    <div class="grid__item nine-twelfths" style="padding-left: 0px; ">
                                        <input type="text" name="manufactureId" id="manufactureId" readonly="true"
                                            style="width:65%" disabled="disabled">
                                    </div>
                                    <div class="grid__item three-twelfths" style="margin-top: 23px;">
                                        <h4>Time Created: </h4>
                                    </div>
                                    <div class="grid__item nine-twelfths" style="padding-left: 0px; ">
                                        <input type="text" name="createTime" id="createTime" readonly="true"
                                            style="width:65%" disabled="disabled">
                                    </div>
                                    <div class="grid__item three-twelfths" style="margin-top: 23px;">
                                        <h4>Technician ID: </h4>
                                    </div>
                                    <div class="grid__item nine-twelfths" style="padding-left: 0px;">
                                        <input type="text" name="techId" id="techId" readonly="true" style="width:65%"
                                            disabled="disabled">
                                    </div>
                                    <div class="grid__item three-twelfths" style="margin-top: 23px;">
                                        <h4>State: </h4>
                                    </div>
                                    <div class="grid__item nine-twelfths" style="padding-left: 0px; ">
                                        <input type="text" name="state" id="state" readonly="true" style="width:65%"
                                            disabled="disabled">
                                    </div>
                                    <input type="hidden" name="sessionURLTime" id="sessionUrlTime">
                                    <input type="hidden" name="dtcCodes" id="dtcCodes">
                                </div>
                                <div id="noSessionAttached" class="grid__item one-whole" style="margin-top: 23px;">
                                    <h4>No session attached, this will be created on submission.</h4>
                                </div>

                                <table width="100%" cellpadding="0" cellspacing="0">
                                    <tbody>
                                        <tr>
                                            <td colspan="4" style="text-align: right;">
                                                <input (click)="openModal()" class="btn btn-primary mr-3 shadow-none"
                                                    type="button" value="ADD/CHANGE SESSION">
                                                <input class="btn btn-primary mr-3 shadow-none" id="deleteSession"
                                                    style="display: none;" type="button" value="Remove Session">
                                                <input class="btn btn-primary mr-3 shadow-none" type="submit"
                                                    value="{{'CONTINUE'|translate}}">
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                            </form>
                            <div id="session-dialog"
                                style="display: none; height: 110%; text-align: center; margin-top: 20px">
                                You have indicated that you wish to make a Hotline Assistance Request.

                                Before you continue, it is recommended that you identify the vehicle session associated
                                with
                                this request (if any).

                                Do you wish to attach a session to this request?

                            </div>

                            <div id="session-selection-dialog"
                                style="display: none; height: 100%; width: 100%; margin:0 0 0 0; padding:0 0 0 0; text-align: center; overflow-y:scroll;">
                                <div id="resultSpinner" style="display: none; text-align: center; margin-top: 20px">
                                    <img id="loadSpinnerImg" src="/img/ajax-loader.gif" width="60" height="60"
                                        class="imgNoBorder">
                                </div>
                                <div id="session-selection-dialog-inner"></div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="grid">
            <div>
                <form id="submitGtacCase"
                    action="https://wwwedu.gtac.dealerconnection.com/GTACUiWeb/pages/submitETISTSR.faces" method="post"
                    scope="request" target="_blank">
                    <div id="userInformation">
                        <input type="hidden" name="countryCode" id="countryCode" value="GBR">
                        <input type="hidden" name="langCode" id="langCode" value="en-GB">
                        <input type="hidden" name="userId" id="userId" value="d-kancha">
                        <input type="hidden" name="fName" id="fName" value="DS">
                        <input type="hidden" name="lName" id="lName" value="Kanchana">
                        <input type="hidden" name="email" id="email" value="KDHANASA@ford.com">
                        <input type="hidden" name="vin" id="userVin" value="WF0RXXWPGRHU38253">
                        <input type="hidden" name="smsNumber" id="smsNumber" value="020852634110">
                    </div>
                    <div id="sessionInformation">
                        <input type="hidden" name="odometer" id="odometer" value="">
                        <input type="hidden" name="odoUnit" id="odoUnit" value="">
                        <input type="hidden" name="warrStartDate" id="warrStartDate" value="23/03/2017">
                        <input type="hidden" name="warrantyDealerCode" id="warrantyDealerCode" value="">
                    </div>
                    <div id="dealerInformation">
                        <input type="hidden" name="dealername" id="dealername" value="Ford Training">
                        <input type="hidden" name="pacode" id="pacode" value="GBRTEST11">
                        <input type="hidden" name="manufactureId" id="manufactureId" value="">
                        <input type="hidden" name="createTime" id="createTime" value="">
                        <input type="hidden" name="techId" id="techId" value="">
                        <input type="hidden" name="state" id="state" value="">
                        <input type="hidden" name="sessionURLTime" id="sessionUrlTime" value="">
                        <input type="hidden" name="dtcCodes" id="dtcCodes" value="">
                    </div>
                </form>
            </div>
        </div>
    </div>

</div>
<div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top" style="display: block;"
(click)="topFunction()">
</div>